import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: end;
    flex-wrap: wrap-reverse;
    gap: 0.8rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const Wrapper = styled.div`
    background: ${colors.white};
    border-radius: 6px;
    padding: 20px;
`;

export const ControlsWrapper = styled.div`
    width: 25%;
    min-width: 250px;

    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;
